import { Link } from 'react-router-dom';
import { Button, Skeleton, Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { TripRes } from 'api/swagger';
import { useGetTripsByTruckId } from 'api/trips/use-get-trips-by-truck-id';
import { TripRoute } from 'components/trips/trip-route';
import { TripStatusTag } from 'components/trips/trip-status-tag';
import styles from './truck-trips-list.module.scss';
import type { ITruckTripsListProps } from './types';

export const TruckTripsList: React.FC<ITruckTripsListProps> = (props) => {
  const { truckId, currentTrip, onSelectTrip } = props;

  const { data, isLoading } = useGetTripsByTruckId(truckId);

  if (truckId && isLoading) return <Skeleton active />;

  const truckTrips = data ?? [];
  const hasCurrentTrip = truckTrips.some((trip) => trip.id === currentTrip.id);
  const trips = hasCurrentTrip ? truckTrips : [currentTrip, ...truckTrips];

  const columns: ColumnsType<TripRes> = [
    {
      key: 'action',
      dataIndex: 'id',
      render: (_: number, trip) =>
        trip.id === currentTrip.id ? (
          <Tag color='blue'>Current trip</Tag>
        ) : (
          <Button size='small' onClick={() => onSelectTrip(trip)}>
            View
          </Button>
        ),
    },
    {
      key: 'compositeId',
      dataIndex: 'compositeId',
      render: (compositeId: string, trip) => <Link to={`/trips/${trip.id}`}>{compositeId}</Link>,
    },
    {
      key: 'status',
      dataIndex: 'status',
      render: (status: TripRes['status']) => <TripStatusTag status={status} />,
    },
    {
      key: 'direction',
      dataIndex: 'relatedWarehouseIds',
      render: (relatedWarehouseIds: number[]) => <TripRoute warehousesIds={relatedWarehouseIds} />,
    },
  ];

  return (
    <Table
      className={styles.table}
      rowKey='id'
      columns={columns}
      dataSource={trips}
      showHeader={false}
      pagination={false}
      size='small'
    />
  );
};
